import dayjs from "dayjs";
import { z } from "zod";

export const zodDayjs = z
  .string()
  .nullish()
  .transform((dateString, ctx) => {
    return dayjs(dateString);
  });

export const processData = <A extends z.ZodTypeAny, B = z.infer<A>>(
  schema: A,
  data: any,
  onlySuccess: boolean = false
) => {
  const result = schema.safeParse(data);
  if (!result.success) {
    console.error(result.error.errors);
    return onlySuccess ? undefined : data;
  }

  if (result.data === "") {
    return onlySuccess ? undefined : Promise.resolve({} as B);
  }

  return result.data as B;
};
